import { HTMLMotionProps } from 'framer-motion'

const feedbackMessageAnimation: HTMLMotionProps<'div'> = {
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: {
    duration: 0.15,
    ease: 'easeInOut',
  },
  variants: {
    hidden: { x: '100px', opacity: 0 },
    visible: { x: '0', opacity: 1 },
  },
}

export default feedbackMessageAnimation
